export default __webpack_public_path__ + "static/media/1-5-1.45e50083.jpg";